module.exports = __webpack_public_path__ + "img/gift4.44089e2c.png";